// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridRandomizeBody = {
  poolId: string;
  gridId: string;
};

export type typeSquaresGridRandomizeOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      gridState: "open" | "locked" | "live" | "final" | "void";
      publishStatus: "draft" | "published";
      hasNumbers: boolean;
    };
  };
};

export type typeSquaresGridRandomizeOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridRandomizeOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridRandomizeOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridRandomizeBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "gridId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridRandomize(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridRandomizeBody);
  }

  return async function postSquaresGridRandomize(
    payload: typeSquaresGridRandomizeBody,
  ): Promise<
    typeSquaresGridRandomizeOutput200 | typeSquaresGridRandomizeOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridRandomize" failed before calling the network. #92d62146643a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#92d62146643a" },
        },
        data: null,
      } as typeSquaresGridRandomizeOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-randomize`,
      httpMethod: "POST",
      options,
    })) as
      typeSquaresGridRandomizeOutput200 | typeSquaresGridRandomizeOutput400;
  };
}
